import { render } from "./BadgeSettings.vue?vue&type=template&id=5afc8702"
import script from "./BadgeSettings.vue?vue&type=script&lang=js"
export * from "./BadgeSettings.vue?vue&type=script&lang=js"
script.render = render

export default script